import React, { useState } from "react";
import InputField from "../components/InputField";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { addValuation } from "../store/valuation/actions/actionsCreators";
import { carValuationSchema } from "../Schema/Schema";

const CarValuationForm = () => {
  const [loading, setLoading] = useState(false);
  console.log(loading);

  const dispatch = useDispatch();
  const initialValues = {
    registrationNumber: "",
    vehicleMake: "",
    model: "",
    year: "",
    mileage: "",
    name: "",
    email: "",
  };
  const { handleChange, handleSubmit, values, errors, touched, resetForm } =
    useFormik({
      initialValues,
      validationSchema: carValuationSchema,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          dispatch(addValuation(values, resetForm));
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      },
    });
  return (
    <>
      <div className="container mx-0 mx-sm-0 mx-md-auto mx-lg-auto my-5">
        <div className="row">
          <div className="col-xxl-8 col-lg-7">
            <div className="card shadow-sm p-4 rounded-lg mx-auto">
              <div className="title-area mb-2">
                <span className="sub-title">Sell Your Car?</span>
                <h2 className="sec-title fs-4">We buy cars</h2>
              </div>
              <div className="text-center mb-4">
                <h3 className="fw-bold">Online Car Valuation</h3>
                <p className="text-muted">
                  Complete the form below to receive an estimated valuation for
                  your car.
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <InputField
                      type="text"
                      label="Registration No *"
                      name="registrationNumber"
                      onChange={handleChange}
                      value={values.registrationNumber}
                      error={errors.registrationNumber}
                      touched={touched.registrationNumber}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputField
                      type="text"
                      label="Vehicle Make *"
                      name="vehicleMake"
                      onChange={handleChange}
                      value={values.vehicleMake}
                      error={errors.vehicleMake}
                      touched={touched.vehicleMake}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputField
                      type="text"
                      label="Model *"
                      name="model"
                      onChange={handleChange}
                      value={values.model}
                      error={errors.model}
                      touched={touched.model}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputField
                      type="text"
                      label="Year *"
                      name="year"
                      onChange={handleChange}
                      value={values.year}
                      error={errors.year}
                      touched={touched.year}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputField
                      type="text"
                      label="Mileage *"
                      name="mileage"
                      onChange={handleChange}
                      value={values.mileage}
                      error={errors.mileage}
                      touched={touched.mileage}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputField
                      type="text"
                      label="Name *"
                      name="name"
                      onChange={handleChange}
                      value={values.name}
                      error={errors.name}
                      touched={touched.name}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputField
                      type="email"
                      label="Email *"
                      name="email"
                      onChange={handleChange}
                      value={values.email}
                      error={errors.email}
                      touched={touched.email}
                    />
                  </div>
                </div>

                <div className="d-flex  mt-4">
                  <button type="submit" className="btn style2">
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submit
                      </>
                    ) : (
                      <>
                        Submit <i className="fas fa-arrow-right ms-2" />
                      </>
                    )}
                  </button>
                </div>
              </form>

              <div className="text-muted mt-3">
                <p>
                  We take the hassle out of selling privately plus we have a
                  network of industry contacts looking to pay good prices for
                  your vehicle.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xxl-4 col-lg-5">
            <aside className="sidebar-area ">
              <div className="widget widget_categories">
                <h3 className="widget_title">Contact Details</h3>
                <div className="d-flex align-items-center mb-3">
                  <div>
                    <p className="mb-0 fw-semibold">Call Us:</p>
                    <p className="text-muted mb-0"> 07496360002</p>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-3">
                  <div>
                    <p className="mb-0 fw-semibold">Email:</p>
                    <p className="text-muted mb-0">
                      inquiry@silverlineautoltd.co.uk
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <div>
                    <p className="mb-0 fw-semibold">Address:</p>

                    <p className="text-muted mb-0">
                      UNIT 2 POOL ROAD INDUSTRIAL ESTATE NUNEATON, CV10 9AE,
                      United Kingdom
                    </p>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarValuationForm;
